exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-body[data-v-6504d548] {\n  width: 100%;\n  padding: 0.052083rem;\n}\n.icon-body .icon-list[data-v-6504d548] {\n  height: 1.041667rem;\n  overflow-y: scroll;\n}\n.icon-body .icon-list div[data-v-6504d548] {\n  height: 0.15625rem;\n  line-height: 0.15625rem;\n  margin-bottom: -0.026042rem;\n  cursor: pointer;\n  width: 33%;\n  float: left;\n}\n.icon-body .icon-list span[data-v-6504d548] {\n  display: inline-block;\n  vertical-align: -0.15em;\n  fill: currentColor;\n  overflow: hidden;\n}", ""]);

// exports
